import React from "react";
import {
  NavLink as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { ROLES } from "~routes/constants";

const NavLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(
  function Link(itemProps, ref) {
    return (
      <li>
        <RouterLink ref={ref} {...itemProps} role={ROLES.admin} />
      </li>
    );
  }
);

export default NavLink;
